import React, { useEffect, useState } from "react";
import { Pie } from "@ant-design/plots";
import styled from "@emotion/styled";
import { Col, Row, Spin, Select, Form, } from "antd";
import { chain, map } from "lodash";
// Redux
import {
  getLocations,
  getUserRoleId,
  getSelectedDepartmentId,
  getClientid,
  getUserList,
  getUserInfo,
} from "redux/selectors";

import { CALL_API } from "common/API";
import { size, includes, some } from "lodash";
import LocationBasedAttendanceList from "./LocationBasedAttendanceList";
import { getLoadingRoute, getCRMManagingOfficeList } from "redux/selectors";
import { connect, useSelector } from "react-redux";
import { uniqBy } from "lodash";
import { STATUS_CODE, CountryFilterResourcePlanning } from "common/Constants";



const StyledChartContainer = styled.div`
  min-height: 504px;
  padding: 20px !important;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  border-radius: 8px !important;

  .name-title {
    padding: 3px 10px;
    font-size: 1rem;
    padding-bottom: 15px;
    font-weight: 600;
  }

  .rowstyle {
    display: flex;
    /* flex-direction: column; */
    justify-content: space-between;
  }

  .legends {
    padding-top: 3px;
    display: flex;
    width: 100%;
    justify-content: center;
    flex-direction: column;
    gap: 4px;
    padding: 16px;
    div {
      display: flex;
      justify-content: start;
      align-items: center;
    }
    .legend-box {
      width: 100%;
      display: flex;
      justify-content: start;
      align-items: center;
      gap: 12px;
      font-size: 12px;
      font-weight: 500;
      @media (max-width: 426px) {
        font-size: 8px;
      }
      strong {
        margin-left: auto;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
`;

const StyledColorBox = styled.span`
  ${({ color }) => color && `background: ${color};`}
  /* padding: 0px 16px; */
  height: 14px;
  width: 28px;
  border-radius: 10px;
`;

function LocationBasedPresentStaff({
  locationList,
  userRoleId,
  selectedDepartmentId,
  ClientId,
  myTeam,
  getSubordinates,
  userList,
  isHrDashboard,
  userInfo, isMyTeam
}) {
  const [displayReportLoader, toggleReportLoader] = useState(false);
  const [reportData, setReportData] = useState([]);
  const filteruser = userList?.filter(
    (item) => item?.userid === userInfo.userid
  );
  const [reportList, setReportList] = useState([]);
  const [locationName, setLocationName] = useState("");
  const [displayAttendanceStaffModal, toggleDisplayAttendanceStaffModal] =
    useState(false);
  const crmManagingOfficeList = useSelector(getCRMManagingOfficeList)
  const [selectedManagingOffice, setSelectedManagingOffice] = useState(filteruser[0]?.managingoffice);
  const [form] = Form.useForm();



  const getReportData = async () => {
    toggleReportLoader(true);
    if (ClientId) {
      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      await delay(100);

      let subOrdinatesList = [""];

      if (myTeam) {
        const subOrdinates = [...new Set(getSubordinates(myTeam))];
        subOrdinatesList = subOrdinates?.length > 0 ? subOrdinates : [""];
      } else if (isHrDashboard) {
        subOrdinatesList = [""];
      }

      const { locationList } = await CALL_API(
        `location-list/${ClientId}`,
        "post",
        {
          // departmentId:
          //   userRoleId != 6 || userRoleId != 1 ? selectedDepartmentId : [""],
          officesupervisorid: myTeam
            ? filteruser?.OfficeSupervisorId === "none"
              ? [""]
              : [filteruser[0]?.employeeid]
            : [""],
          country: myTeam ? "" : selectedManagingOffice ? (Array.isArray(selectedManagingOffice) && selectedManagingOffice.length > 0 ? selectedManagingOffice : [selectedManagingOffice]) : filteruser[0]?.managingoffice,
        }
      );

      let lastColor = "#C7F9E7";

      const getRandomColor = (lastColor) => {
        let color = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
        if (color === lastColor || color === "#ffffff") {
          return getRandomColor(lastColor);
        }
        lastColor = color;
        return color;
      };

      let locationDetails = locationList?.filter((item) => {
        const findUser = userList?.find((user) => {
          return user.userid === item?.userid;
        });
        if (filteruser[0].OfficeSupervisorId === "none") {
          const userDetails = userList?.find((user) => {
            return user.userid === item?.userid;
          });
          return userDetails;
        } else {
          const userDetails = some(findUser?.managingoffice, (value) =>
            includes(filteruser[0]?.managingoffice, value)
          );
          return userDetails;
        }
      });
      let result = chain(locationList)
        .filter(x => x.country) // remove bad records safely
        .groupBy(x => x.country)
        .map((value, key) => ({
          loginLocationName: key,   // <-- country name (Kenya)
          prensentList: value,      // <-- array of users in that country
          presentCount: size(value),
          color: getRandomColor(lastColor),
        }))
        .value();

      console.log(result, "dadgwgdh");

      setReportData(result);

      toggleReportLoader(false);
    }
  };
  useEffect(() => {
    getReportData();
  }, [selectedDepartmentId]);

  const config = {
    // height:350,
    padding: "auto",
    data: reportData,
    angleField: "presentCount",
    colorField: "loginLocationName",
    radius: 0.7,
    color: map(reportData, "color", []),
    label: {
      type: "inner",
      offset: "-30%",
      autoRotate: false,
      // content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
      style: {
        fontSize: 12,
        textAlign: "center",
      },
    },
    legend: false,
    // legend: {
    //   position: "right",
    //   layout: "vertical",
    //   offsetX: -30,
    //   itemName: {
    //     // formatter: (text,item) => {
    //     //   return " hi all the user interface check nterface"
    //     // },
    //     style: {
    //       fontSize: 18,
    //     },
    //   },
    //   marker: {
    //     radius: 12,
    //     style: {
    //       r: 6,
    //     },
    //   },
    // },
    interactions: [
      {
        type: "element-active",
      },
    ],
  };

  const uniquemanagingOffice = uniqBy(
    crmManagingOfficeList?.map((item) => {
      return { label: item?.Label, value: item?.Value };
    }),
    "value"
  );

  const handleFormChange = (value) => {
    setSelectedManagingOffice(value || "");
  };

  useEffect(() => {
    if (selectedManagingOffice !== undefined) {
      getReportData();
    }
  }, [selectedManagingOffice]);


  return (
    <>
      <Spin spinning={displayReportLoader}>
        <StyledChartContainer>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="name-title">Today's Location based Attendance</div>

            {filteruser[0]?.roleid?.includes("2") && !isMyTeam && (
              <Select
                showSearch
                placeholder="Select Country"
                labelInValue
                style={{ width: 200 }}
                onChange={(option) => {
                  form.setFieldsValue({ managingoffice: option });
                  handleFormChange(option.label);
                }}
              >
                {uniqBy(
                  CountryFilterResourcePlanning?.map((item) => ({
                    label: item.country,
                    value: item.country,
                  })),
                  "value"
                )?.map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            )}
          </div>

          {reportData?.length > 0 ? (
            <Row className="rowstyle">
              <Col span={16}>
                <Pie
                  {...config}
                  onEvent={(plot) => {
                    plot.on("element:click", (x) => {
                      setLocationName(x.data.data.loginLocationName);
                      setReportList(x.data.data.prensentList);
                      toggleDisplayAttendanceStaffModal(true);
                    });
                  }}
                />
              </Col>
              <Col span={8} className="legends">
                {reportData.map((val) => {
                  return (
                    <div>
                      <div className="legend-box">
                        <StyledColorBox color={val.color}></StyledColorBox>
                        {val.prensentList[0]?.country}{" "}
                        {/* <strong>{val.presentCount}</strong> */}
                      </div>
                    </div>
                  );
                })}
              </Col>
            </Row>
          ) : (
            <p
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              No Staff Present
            </p>
          )}
        </StyledChartContainer>
      </Spin>
      <LocationBasedAttendanceList
        displayModal={displayAttendanceStaffModal}
        toggleModal={() => toggleDisplayAttendanceStaffModal(false)}
        title={locationName}
        list={reportList}
        reportType={locationName}
        userList={userList}
        userInfo={userInfo}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  locationList: getLocations(state),
  userRoleId: getUserRoleId(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  ClientId: getClientid(state),
  userList: getUserList(state),
  userInfo: getUserInfo(state),
});

export default connect(mapStateToProps, null)(LocationBasedPresentStaff);